import { render, staticRenderFns } from "./VacancyHeading.vue?vue&type=template&id=514c341a&"
import script from "./VacancyHeading.vue?vue&type=script&lang=js&"
export * from "./VacancyHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports